import { Box } from '@chakra-ui/layout'

export const OptInIcon = ({ ...props }) => {
  return (
    <Box {...props}>
      <svg
        width='82'
        height='65'
        viewBox='0 0 82 65'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M26.4062 44.6875H25.8984C24.1211 45.3223 22.2168 45.7031 20.3125 45.7031C18.2812 45.7031 16.377 45.3223 14.5996 44.6875H14.2188C6.34766 44.6875 0 51.1621 0 58.9062C0 62.334 2.66602 65 6.09375 65H34.5312C37.832 65 40.625 62.334 40.625 58.9062C40.625 51.1621 34.1504 44.6875 26.4062 44.6875ZM75.1562 0H26.4062C22.9785 0 20.3125 2.91992 20.3125 6.34766V12.1875C23.2324 12.1875 26.0254 13.0762 28.4375 14.4727V8.125H73.125V44.6875H38.9746C41.3867 46.8457 43.1641 49.6387 44.0527 52.8125H75.1562C78.457 52.8125 81.25 50.0195 81.25 46.5918V6.34766C81.25 2.91992 78.457 0 75.1562 0ZM20.3125 40.625C27.041 40.625 32.5 35.293 32.5 28.4375C32.5 21.709 27.041 16.25 20.3125 16.25C13.457 16.25 8.125 21.709 8.125 28.4375C8.125 35.293 13.457 40.625 20.3125 40.625ZM41.6406 21.3281C40.498 20.0586 38.5938 20.0586 37.4512 21.3281L35.5469 23.1055C36.0547 24.8828 36.5625 26.6602 36.5625 28.4375C36.5625 29.3262 36.4355 30.2148 36.1816 30.9766L39.6094 27.6758L46.5918 34.6582C47.7344 35.9277 49.6387 35.9277 50.7812 34.6582L59.9219 25.5176L63.0957 28.6914C64.4922 30.0879 67.0312 29.0723 67.0312 27.041V15.7422C67.0312 14.9805 66.2695 14.2188 65.5078 14.2188H54.209C52.1777 14.2188 51.1621 16.7578 52.5586 18.1543L55.7324 21.3281L48.75 28.3105L41.6406 21.3281Z'
          fill='#2D3748'
        />
      </svg>
    </Box>
  )
}
